import { render, staticRenderFns } from "./ServiceRequestInvoice.vue?vue&type=template&id=1f3abe8f&scoped=true"
import script from "./ServiceRequestInvoice.vue?vue&type=script&lang=js"
export * from "./ServiceRequestInvoice.vue?vue&type=script&lang=js"
import style0 from "./ServiceRequestInvoice.vue?vue&type=style&index=0&id=1f3abe8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3abe8f",
  null
  
)

export default component.exports